import React from 'react';
import PropTypes from 'prop-types';
import 'styles/alert.css';

const StateAlert = ({ isBorrador }) => {
  let alertClass = 'alert-success';
  let alertText = 'Ejecutado';
  if(isBorrador) {
    alertClass = 'alert-primary';
    alertText = 'Borrador';
  }
  return(
    <div className={`alert ${alertClass} text-center`} role="alert">
      {alertText}
    </div>
  )
};

StateAlert.propTypes = {
  isBorrador: PropTypes.bool,
};

StateAlert.defaultProps = {
  isBorrador: false,
};

export default StateAlert;
